import script from "./TraditionalMachineryOperation.vue?vue&type=script&setup=true&lang=js"
export * from "./TraditionalMachineryOperation.vue?vue&type=script&setup=true&lang=js"

import "./TraditionalMachineryOperation.vue?vue&type=style&index=0&id=1e35cbee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e35cbee"]])

export default __exports__